import { render, staticRenderFns } from "./ListDissertation_council.vue?vue&type=template&id=71a0650f&scoped=true"
import script from "./ListDissertation_council.vue?vue&type=script&lang=js"
export * from "./ListDissertation_council.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a0650f",
  null
  
)

export default component.exports